import * as React from 'react'
import { HashRouter as Router, useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import MyRouter from '@feedback/router/index'
import './App.scss'
import { getAppConfig } from '@feedback/utils/CONST'
import {
  applyVestSiteTokens,
  getCurrentVestSite,
  getVestBodyClasses,
  initVestSiteIdentity
} from '@feedback/utils/siteConfig'
import { Toaster } from 'react-hot-toast'
import { getLangKey } from '../../utils/util'
import clsx from 'clsx'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

function ScrollToTop() {
  const { pathname } = useLocation()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default function App(): JSX.Element {
  // 马甲站：在 getAppConfig / body class 之前完成 hostname / site 参数解析
  // 同时注入站点级 CSS 变量 token（logo/品牌色）
  initVestSiteIdentity()

  const { appid } = getAppConfig() || {}
  if (appid) {
    document.body.classList.add(appid)
  }
  // 仅马甲站追加 vest + 站点标识 class；既有 appid 无任何新增 class
  getVestBodyClasses(appid).forEach((cls) => {
    document.body.classList.add(cls)
  })
  // body.vest 挂好后，确保异常路径也有兜底 token（正常路径 init 已注入）
  const vestSite = getCurrentVestSite()
  if (vestSite || document.body.classList.contains('vest')) {
    applyVestSiteTokens(vestSite)
  }

  const langKey = getLangKey()
  const isRTL = langKey === 'ar-SA'

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <Toaster />
        <div
          className={clsx('limit-width-root', isRTL && 'rtl-mode')}
          dir={isRTL ? 'rtl' : 'ltr'}
        >
          <MyRouter />
        </div>
      </Router>
    </QueryClientProvider>
  )
}
